import React from 'react';
import { renderToStaticMarkup } from 'react-dom/server';
import { getTooltipStyles } from './styleUtils';
import { Tooltip as RTooltip, PlacesType } from 'react-tooltip';

export interface TooltipProps {
	content?: React.ReactNode;
	theme?: 'dark' | 'light';
	position?: PlacesType;
	children: React.ReactNode;
}

export const Tooltip: React.FC<TooltipProps> = ({
	content,
	theme = 'light',
	position,
	children
}) => {
	const styles = getTooltipStyles();
	return (
		<>
			<div
				data-tooltip-id="my-tooltip"
				style={styles.tooltipWrapperCss}
				data-tooltip-html={renderToStaticMarkup(<>{content}</>)}
			>
				{children}
			</div>
			<RTooltip id="my-tooltip" place={position} style={styles.containerCss(theme)} />
		</>
	);
};
